import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

import { cleanName, orNull } from '../../../common/utils/text';
import { useCreateRace } from '../contexts/races';
import { validateRace } from '../utils/validate';
import RaceFields from './fields';

import '../../../common/styles/catalog.css';

const EMPTY = { name: '', code: '' };

export default function CreateRaceForm() {
    const navigate = useNavigate();
    const { mutateAsync, isPending } = useCreateRace();

    const [form, setForm] = useState(EMPTY);
    const [localErrors, setLocalErrors] = useState({});
    const [serverFields, setServerFields] = useState({});

    const setField = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
        if (localErrors[field] || serverFields[field]) {
            setLocalErrors(prev => ({ ...prev, [field]: undefined }));
            setServerFields(prev => ({ ...prev, [field]: undefined }));
        }
    };
    const fieldError = (field) => localErrors[field] || serverFields[field];

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateRace(form);
        if (Object.keys(errors).length) { setLocalErrors(errors); return; }
        setLocalErrors({});
        setServerFields({});

        try {
            await mutateAsync({ name: cleanName(form.name), code: orNull(form.code) });
            toast.success('Raza creada');
            navigate('/admin/races');
        } catch (err) {
            if (err?.status === 409) toast.error('Ya existe una raza con ese nombre o código');
            else if (err?.fields) { setServerFields(err.fields); toast.error('Revisá los campos marcados'); }
            else toast.error(err?.message || 'No se pudo crear la raza');
        }
    };

    return (
        <form className="cat-form" onSubmit={handleSubmit}>
            <header className="cat-form__header">
                <Link to="/admin/races" className="cat-form__back">Razas</Link>
                <h1 className="cat-form__title">Nueva raza</h1>
            </header>

            <RaceFields form={form} setField={setField} fieldError={fieldError} disabled={isPending} />

            <footer className="cat-form__footer">
                <Link to="/admin/races" className="cat-form__cancel">Cancelar</Link>
                <button type="submit" className="cat-form__submit" disabled={isPending || !form.name.trim()}>
                    {isPending ? 'Creando…' : 'Crear raza'}
                </button>
            </footer>
        </form>
    );
}
